<script>
export default {
  props: {
    opcoes: {
      type: Object,
      required: true
    },
    valorPadrao: {
      type: Object
    }
  },
  data () {
    return {
      mostrarOpcoes: false,
      opcaoSelecionada: null,
      selectedText: 'Selecione uma opção'
    }
  },
  methods: {
    toggleopcoes () {
      this.mostrarOpcoes = !this.mostrarOpcoes

      if (this.mostrarOpcoes) {
        document.addEventListener('click', this.AlterarVisibilidadeOpcoes)
      } else {
        document.removeEventListener('click', this.AlterarVisibilidadeOpcoes)
      }
    },
    SelecionarOpcao (option) {
      this.opcaoSelecionada = option.value
      this.selectedText = option.label
      this.$emit('opcaoSelecionada', this.opcaoSelecionada)
    },
    AlterarVisibilidadeOpcoes (event) {
      if (!this.$refs.customSelect.contains(event.target)) {
        this.mostrarOpcoes = false
        document.removeEventListener('click', this.AlterarVisibilidadeOpcoes)
      }
    },
    PrencherOpcaoPadrao () {
      const opcaoSelecionada = this.opcoes.find(o => o.value === this.opcaoSelecionada)
      if (opcaoSelecionada) {
        this.selectedText = opcaoSelecionada.label
        return
      }

      if (this.valorPadrao) {
        this.SelecionarOpcao(this.valorPadrao)
        this.selectedText = opcaoSelecionada.label
        return
      }

      this.selectedText = 'Selecione uma opção'
    }
  },
  mounted () {
    this.PrencherOpcaoPadrao()
  }
}
</script>

<template>
  <div class="custom-select" @click="toggleopcoes()" ref="customSelect">
    <div class="selected-option">{{ selectedText }}</div>
    <div class="opcoes" v-show="mostrarOpcoes">
      <div
          @click="SelecionarOpcao(option)"
          class="option" :class="{ 'selected': opcaoSelecionada === option.value }"
          v-for="(option, index) in opcoes" :key="index"
      >
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<style scoped>
  .custom-select {
    position: relative;
    width: auto; 
    cursor: pointer;
  }

  .selected-option {
    padding-top: 2px;
  }

  .opcoes {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 200px; /* Tamanho do opcoes */
    overflow-y: auto;
    background-color: #fff;
    border: 1px solid #ccc;
    z-index: 2;
  }

  .option {
    padding: 10px;
  }

  .option:hover {
    background-color: #f2f2f2;
  }
  .selected {
    background-color: #cfd8e2;
  }
</style>


// WEBPACK FOOTER //
// select-altura-limitada.vue?8e51fa8a